<template>
  <div class="about-us">
    <h3>关于我们</h3>

    <div v-if="intro" class="intro">
      {{ intro.artAbstract }}
      <span class="more" @click="() => clickNews(intro)">更多</span>
    </div>

    <!-- 轮播图 -->
    <van-swipe :autoplay="3000" indicator-color="#588bf2">
      <van-swipe-item v-for="(item, index) in carouselData" :key="index">
        <div class="swipe-item">
          <img :src="item.showIcon" />
          <div>
            <span class="count">{{ item.count }}</span>
            <span class="unit">{{ item.unit }}</span>
          </div>
          <div class="title">{{ item.title }}</div>
        </div>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import codes from '@/api/codes';
import { configureParams } from '@/assets/js/configureParams';

export default {
  name: 'AboutUs',

  data() {
    return {
      carouselData: [
        {
          showIcon: 'https://www.jchc.cn/storage/sjk/b09d85a5-4970-4e4a-bd60-73561700ecae.png',
          title: '全口径总资产',
          count: 11117,
          unit: '亿',
        },
        {
          showIcon: 'https://www.jchc.cn/storage/sjk/28e35c6e-e280-4718-a3e4-800ea4ac6dca.png',
          title: '净资产',
          count: 4391,
          unit: '亿',
        },
        {
          showIcon: 'https://www.jchc.cn/storage/sjk/79c3df0e-d85a-48dd-8613-e0edf5970e15.png',
          title: '下辖企事业单位',
          count: 35,
          unit: '',
        },
        {
          showIcon: 'https://www.jchc.cn/storage/sjk/6cb187ef-184f-44e3-bf67-b33073c8914d.png',
          title: '控股上市企业',
          count: 3,
          unit: '',
        },
        {
          showIcon: 'https://www.jchc.cn/storage/sjk/4156cde5-8e39-433b-9918-e0cf2e5534cf.png',
          title: '员工人数',
          count: 2.6,
          unit: '万+',
        },
      ],
      intro: null,
    };
  },

  mounted() {
    this.loadIntro();
  },

  methods: {
    /** 加载公司简介 */
    loadIntro() {
      let replacement = {
        subjectId: 1,
        menuId: 2,
      };
      this.$api.getMenuArticle(replacement).then((res) => {
        this.intro = res.articleList[0];
      });
    },

    // 点击新闻
    clickNews(articleData) {
      let replacement = {
        subjectId: codes.SUBJECT_ID,
        articleId: articleData.id,
      };
      // this.$api.countClick(replacement)
      //   .then(data => {
      //     return this.$api.getArticleUpMenus(replacement)
      //   })
      // 获取文章的上级菜单结构
      this.$api.getArticleUpMenus(replacement).then((data) => {
        this.$router.push({
          path: '/content',
          query: configureParams(data, articleData, codes.ARTICLE),
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.about-us {
  padding: 0 40px;
  margin-top: 70px;

  > h3 {
    font-size: 42px;
    font-weight: 500;
    color: #333333;
    line-height: 59px;
  }
  .intro {
    margin: 37px 0;
    font-size: 26px;
    font-weight: 400;
    color: #8e8e8e;
    line-height: 46px;
    position: relative;

    .more {
      position: absolute;
      color: #3a8bf3;
      right: 30px;
    }
  }

  .swipe-item {
    height: 517px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      width: 82px;
      margin-bottom: 45px;
    }

    .count {
      font-size: 113px;
      font-weight: 500;
      color: #ffffff;
      line-height: 144px;
      font-family: 'Rajdhani-Medium';
    }
    .unit {
      margin-left: 10px;
      font-size: 48px;
      font-weight: 400;
      color: #ffffff;
      line-height: 62px;
    }
    .title {
      margin-top: 36px;
      font-size: 28px;
      font-weight: 500;
      color: #ffffff;
      line-height: 40px;
    }
  }

  .van-swipe {
    background: center / cover no-repeat url('~@/assets/image/content-bg.jpg');

    /deep/ .van-swipe__indicators {
      .van-swipe__indicator {
        width: 27px;
        height: 4px;
        border-radius: 2px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/AboutUs.vue